import React from 'react';

import ListChecklistIcon from '@atlaskit/icon/core/list-checklist';

export const FindActionItemsIcon = (): React.JSX.Element => (
	<ListChecklistIcon label="" color="currentColor" spacing="spacious" />
);
